import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';


@Injectable({
   providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {

   constructor(private loaderService: LoaderService) {

   }
   public intercept(req: HttpRequest<any>, next: HttpHandler):
      Observable<HttpEvent<any>> {

      this.showLoader();

      const res = next.handle(req);
      return res.pipe(
         finalize(() => {
            this.hideLoader();
         })
      );
   }
   private showLoader(): void {
      this.loaderService.show();
   }

   private hideLoader(): void {
      this.loaderService.hide();
   }

}
